import React from "react";
import { Layout } from '@abyss/web/ui/Layout';
import { Link } from '@abyss/web/ui/Link';
import { Divider } from '@abyss/web/ui/Divider';
import { styled } from '@abyss/web/tools/styled';
import { IFooterListSecondary } from "./interfaces/IFooterListSecondary";

interface FooterListSecondaryProps {
    data : IFooterListSecondary[]
}

const StyledLink = styled(Link, {
    fontSize: '9px!important'
});
const StyledDivider = styled(Divider, {
    marginTop: '6px!important'
});

const FooterListSecondary: React.FC<FooterListSecondaryProps> = ({data}: FooterListSecondaryProps) => {
    return (
        <Layout.Group>
                {
                    data.map((item) => {
                        return <React.Fragment key={`footerSecondaryListLink${item.key}`}> 
                        <StyledLink color="$primary2" href={item.Url}>
                            {item.Text}
                            </StyledLink>
                            {
                                item.key < data.length ?
                                <StyledDivider orientation="vertical" height={10} width={1} /> : null
                            }
                            </React.Fragment>
                    })
                }
            </Layout.Group>
    )
}

export {FooterListSecondary}